import {h, Component} from 'preact';
export default class Cancel extends Component {
    render() {
        let {color } = this.props
        return (
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 42 42" height='20px'>
                <path fill={color} d="M23.83,21,37.16,7.69a2,2,0,0,0-2.84-2.84L21,18.19,7.66,4.85A2,2,0,1,0,4.82,7.69L18.15,21,4.82,34.36a2,2,0,0,0,2.84,2.84L21,23.86,34.32,37.19a2,2,0,0,0,2.84-2.84Z"/>
            </svg>
        );
    }
}



// WEBPACK FOOTER //
// ./components/SVGImages/Cancel.js